angular.module("app").service( 'Utils',['$rootScope', '$window', 'uploadImageParams', function($rootScope, $window, uploadImageParams){
   this.convertToRequest = function (items) {
       var request = {};
       for(var key in items) {
           if (items.hasOwnProperty(key) && items[key].value) {
               request[key]= items[key].value;
           }
       }
       return request;
   };

   this.isArraysEqual = function (array1, array2) {
        if(array1 === array2){
            return true;
        }
        if(array1.length !== array2.length){
            return false;
        }
        for(var i = 0; i < array1.length; ++i) {
            if (array1[i] !== array2[i]) {
                return false;
            }
        }
        return true;
   };
   this.createReverse = function (obj) {
       var reversed = {};
       for(var key in obj) {
           reversed[obj[key]] = key;
       }
       return reversed;
   };
    /**
     * Save env to storage
     */
   this.saveEnvToStorage = function () {
       $window.localStorage.setItem("env", JSON.stringify($rootScope.env));
   };
    /**
     * Load env from storage
     */
   this.loadEnvFromStorage = function () {
       if (!$rootScope.env) {
           var envJSON = $window.localStorage.getItem("env");
           if (envJSON) {
               $rootScope.env = JSON.parse(envJSON);
           } else {
               $rootScope.env = {};
           }
       }
   };
    /**
     * Copy given string into clipboard
     * @param str
     */
   this.copyToClipboard = function copyToClipboard(str) {
       var el = document.createElement('textarea');
       el.value = str;
       el.setAttribute('readonly', '');
       el.style = {position: 'absolute', left: '-9999px'};
       document.body.appendChild(el);
       el.select();
       document.execCommand('copy');
       document.body.removeChild(el);
   };

   this.fixImageBase64URL = function fixImageBase64URL(file, urlText) {
       var name = file.name;
       if (name && name.indexOf("?") > 0) {
           name = name.substr(0, name.indexOf("?"));
       }
        if (name && name.endsWith(".jpg")) {
            return urlText.replace("data:image/jpeg;", "data:image/jpg;")
        } else {
            return  urlText;
        }
   };

   this.getBlob = function getBlob(src, load) {
       if (src) {
           var x = new XMLHttpRequest();
           x.open('GET', src);
           x.responseType = 'blob';
           x.onload = function () {
               var blob = x.response;
               var fr = new FileReader();
               fr.onloadend = function () {
                   var copyBlob = null;
                   if (angular.isObject(blob)) {
                       copyBlob =  angular.copy(blob);
                       copyBlob.name = src;
                   } else {
                       copyBlob = blob;
                   }

                   !!load && load(copyBlob, fr.result);
               };
               fr.readAsDataURL(blob);
           };
           x.send();
       }

   };
    this.checkFileAndMakeWarning = function (file, logger) {

        if (file.type === 'image/gif') {
            logger.logWarning(`GIFs can’t be converted to WebP and may affect performance.`);
        }

        var size = file.type === 'image/gif'?uploadImageParams.gifWarningSize: uploadImageParams.imageWarningSize
        if (file.size > size && file.size < uploadImageParams.imageSiza) {
            var fileSizeConvert = file.size / 1048576;
            logger.logWarning((file.type === 'image/gif'?"Max recommended GIF file size is 1MB. Your file is ": "Max recommended file size is 400kb. Your file is ") + ' ' + fileSizeConvert.toFixed(2) + 'MB');
        }
    };
}]);
